import React from "react";
import { useServicesEditor } from "../hooks/useServicesEditor";
import { TrainingSection, DevelopmentSection, FeedbackSection, MealsSection } from "./services/ServiceSections";

export default function ServicesEditor({ participant, onChange }) {
  const s = useServicesEditor(participant, onChange);
  const { svc } = s;
  return (
    <div className="space-y-8">
      {["football", "goalkeeper"].map((key) => (
        <TrainingSection key={key} svcKey={key} s={svc[key]} groupName={`${key}-${participant._k}`}
          onType={(v) => s.setTrainingType(key, v)} onCycleDay={(d) => s.cycleDay(key, d)} />
      ))}
      <DevelopmentSection on={svc.development_package} onToggle={s.toggleDevelopment} />
      <FeedbackSection fb={svc.feedback} disabled={svc.development_package} groupName={`fb-${participant._k}`}
        onType={s.setFeedbackType} onToggleDay={s.toggleFeedbackDay} />
      <MealsSection mealDays={svc.meals.days || []} td={s.td} dietary={participant.meal_dietary}
        onToggle={s.toggleMeal} onDietary={s.setDietary} />
    </div>
  );
}
